module.exports = __webpack_public_path__ + "img/face6.84e724b2.png";